<template>
  <div>
    <BModal
      id="modal-redeem"
      ref="modal-redeem"
      hide-footer
      hide-header
      centered
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
    >
      <ValidationObserver
        #default="{ invalid }"
        ref="form"
      >
        <BRow class="justify-center my-1 flex flex-column items-center gap-1">
          <BCol class="flex justify-center mb-1">
            <div class="text-[#333333] font-semibold text-2xl">
              Konfirmasi Penukaran
            </div>
          </BCol>
          <BCol cols="8">
            <Voucher
              :kompoints="kompoints"
              :voucher="voucher"
            />
          </BCol>
          <BCol>
            <BFormGroup>
              <template #label>
                <div class="text-black flex items-center">
                  <span class="text-base">Kartu Tujuan</span>
                  <span class="text-primary">*</span>
                </div>
              </template>
              <ValidationProvider
                #default="{ errors }"
                name="Kartu Tujuan"
                rules="required"
              >
                <VSelect
                  v-model="cardId"
                  placeholder="Pilih kartu"
                  label="card_name"
                  :options="optionsCards"
                  :reduce="option => option.value"
                  :loading="isLoading"
                >
                  <template #no-options>
                    Tidak ada kartu
                  </template>
                  <template #option="{ card_name }">
                    <div class="flex items center gap-2">
                      <img
                        class="w-6"
                        src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/card.svg"
                        alt="komcard"
                      >
                      <span class="text-black">{{ card_name }} </span>
                    </div>
                  </template>
                </VSelect>
                <small class="text-danger">{{ errors[0] }}</small>
              </ValidationProvider>
            </BFormGroup>
          </BCol>
          <BCol class="text-base">
            <div
              v-for="(price, idx) in prices"
              :key="idx"
              class="flex items-center justify-between"
            >
              <div class="text-black">
                {{ price.text }}
              </div>
              <div :class="price.color">
                {{ price.value }}
              </div>
            </div>
            <hr class="border-[#C2C2C2]">
            <div class="flex items-center justify-between font-medium text-black">
              <div class="text-lg">
                Sisa saldo kompoints
              </div>
              <div>
                {{ IDRWithoutLbl(balanceDifference) }}
              </div>
            </div>
          </BCol>
          <BCol class="flex items-center justify-between text-lg" />
        </BRow>
        <BRow class="mb-1">
          <BCol cols="6">
            <BButton
              variant="outline-primary"
              block
              @click="
                $refs['modal-redeem'].hide()
                cardId = null
              "
            >
              Batal
            </BButton>
          </BCol>
          <BCol cols="6">
            <BButton
              :disabled="invalid"
              :variant="invalid ? 'secondary' : 'primary'"
              type="submit"
              block
              @click.prevent="onRedeem"
            >
              Redeem Sekarang
            </BButton>
          </BCol>
        </BRow>
      </ValidationObserver>
    </BModal>

    <BModal
      id="modal-success"
      ref="modal-success"
      hide-footer
      hide-header
      centered
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
    >
      <BRow class="justify-center my-1 flex flex-column gap-3">
        <BCol class="d-flex justify-content-center">
          <img
            src="https://storage.googleapis.com/komerce/core/icon-popup-success.png"
            alt="Komerce"
          >
        </BCol>
        <BCol class="text-black text-2xl text-center font-medium">
          Berhasil Redeem Voucher
        </BCol>
        <BCol class="text-black text-lg text-center">
          Kamu berhasil redeem voucher sebesar {{ IDR(voucher.amount) }}.
          Sekarang kamu bisa menikmati voucher yang sudah kamu redeem agar bayar
          iklan lebih murah
        </BCol>
      </BRow>
      <BRow class="mb-1">
        <BCol cols="6">
          <BButton
            variant="outline-primary"
            block
            @click="onCloseSuccess"
          >
            Kembali
          </BButton>
        </BCol>
        <BCol cols="6">
          <BButton
            type="submit"
            block
            variant="primary"
            @click="$router.push('/komcards')"
          >
            Lihat mutasi
          </BButton>
        </BCol>
      </BRow>
    </BModal>

    <ModalPIN
      id="modal-verify-pin"
      :no-close-on-backdrop="true"
      :no-close-on-esc="true"
      title="Verifikasi PIN"
      description="Mohon verifikasi identitas kamu dengan masukan PIN"
      label-confirm-button="Konfirmasi"
      label-cancel-button="Kembali"
      @on-confirm-button="onSubmit"
      @on-cancel-button="onClose"
    />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VSelect from 'vue-select'
import { required } from '@validations'
import { newAxiosIns } from '@/libs/axios'
import { IDRWithoutLbl, IDR } from '@/libs/currency'
import ModalPIN from '@/views/components/modal/ModalPIN.vue'
import Voucher from './Voucher.vue'

export default {
  components: {
    Voucher,
    ValidationProvider,
    ValidationObserver,
    VSelect,
    ModalPIN,
  },
  props: {
    kompoints: {
      type: Object,
      default: () => ({}),
    },
    voucher: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      required,
      cardId: null,
      optionsCards: [],
      isLoading: false,
      isLoadingRedeem: false,
      IDRWithoutLbl,
      IDR,
    }
  },
  computed: {
    balanceDifference() {
      return this.kompoints.balance - this.voucher.kompoint_fee
    },
    prices() {
      return [
        {
          text: 'Saldo Kompoints',
          value: this.IDRWithoutLbl(this.kompoints.balance),
          color: 'text-black',
        },
        {
          text: 'Voucher Iklan',
          value: this.IDRWithoutLbl(this.voucher.tax.final_voucher),
          color: 'text-[#D19D04]',
        },
        {
          text: `PPN ${this.voucher.tax.type_tax}%`,
          value: this.IDRWithoutLbl(this.voucher.tax.tax_deduct),
          color: 'text-danger',
        },
      ]
    },
  },
  mounted() {
    this.getListCard()
  },
  methods: {
    async getListCard() {
      this.isLoading = true
      const url = '/komcards/api/v1/card/list'
      const params = {
        limit: 999999,
        offset: 0,
        status: 'active',
        levels: 'platinum',
      }
      await newAxiosIns
        .get(url, { params })
        .then(res => {
          const { data } = res
          const newData = data.data.map(item => ({
            ...item,
            value: item.id,
            card_name: `${item.name} *${this.splitCardNumber(
              item.card_number,
            )}`,
          }))
          this.optionsCards = newData
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false
          this.$toast_error({ message: 'Gagal mendapatkan daftar kartu' })
        })
    },
    async onSubmit(pin) {
      const url = '/komcards/api/v1/voucher/redeem'
      this.isLoadingRedeem = true
      const payload = {
        pin,
        redeem_to: this.cardId,
        voucher_id: this.voucher.id,
      }
      await newAxiosIns
        .post(url, payload)
        .then(() => {
          this.isLoadingRedeem = false
          this.$refs['modal-success'].show()
          this.$bvModal.hide('modal-verify-pin')
          this.$bvModal.hide('modal-redeem')
          this.cardId = null
        })
        .catch(err => {
          const { message } = err.response.data.meta
          this.isLoadingRedeem = false

          if (message === 'card not found') {
            this.$toast_error({ message: 'Kartu tidak ditemukan' })
          }
          if (message === 'card has been freeze') {
            this.$toast_error({ message: 'Kartu tujuan terkena autofreeze oleh sistem. Silakan hubungi CS kami' })
          }
          if (message === 'pending transaction found, cannot proceed') {
            this.$toast_error({ message: 'Transaksi sedang diproses, tidak bisa melanjutkan transaksi lain' })
          }
        })
    },
    onRedeem() {
      this.$bvModal.show('modal-verify-pin')
      this.$bvModal.hide('modal-redeem')
    },
    onCloseSuccess() {
      this.$refs['modal-success'].hide()
      this.$bvModal.hide('modal-verify-pin')
      this.$emit('getVoucherList')
      this.$emit('getKompoints')
      this.cardId = null
    },
    onClose() {
      this.$bvModal.hide('modal-verify-pin')
      this.$bvModal.show('modal-redeem')
    },
    splitCardNumber(number) {
      return number.split(' ').pop()
    },
  },
}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>
